import env from '../lib/env';

export const handleGoogleAuth = () => {
  const TUTORD_API_ORIGIN = env.REACT_APP_TUTORD_API_ORIGIN || 'http://localhost:3001';
  window.location.href = `${TUTORD_API_ORIGIN}/api/v1/auth/google`;
};
